<ng-container *ngIf="socialModalVM$ | async as vm">
  <div class="l_flex guts-p-v-2 user-info-container">
    <div
      class="
        l_flex
        m-l_flex m-l_flex-justify-center
        l_flex-justify
        guts-m-r-1 guts-m-t-1 guts-m-b-1
      "
    >
      <dgx-profile-pic
        [profile]="profile"
        [hideTooltip]="true"
        [showEngagement]="showEngagedLearnerBadge"
        size="large"
      ></dgx-profile-pic>
    </div>
    <div class="l_flex l_flex-grow l_flex-center-children guts-p-full-1">
      <div class="l_flex full-width l_flex-justify">
        <div class="full-width">
          <div class="l_flex m-l_flex m-l_flex-justify-center l_flex-justify">
            <div class="name-pill">
              <div>
                <div
                  *ngIf="showEngagedLearnerBadge"
                  class="
                    badge badge-pill badge-pill--compact
                    guts-m-r-1
                    badge-emphasize
                    active-learner
                    up-me
                    guts-m-b-half
                  "
                  (click)="showEngagedLearnerModal()"
                  tabindex="0"
                  role="button"
                >
                  {{ i18n.Core_ActiveLearner }}
                </div>

                <div
                  *ngIf="mentor.mentorshipStatus === 'Accepted'"
                  class="
                    badge badge-pill badge-pill--compact
                    badge-emphasize
                    up-me
                    guts-m-b-half
                  "
                  role="button"
                >
                  {{ i18n.Opportunities_ConnectWithButton_Status_Accepted }}
                </div>
              </div>

              <h1 class="h1 guts-p-r-1 user-info-name" tabindex="0">
                {{ profile.nameEncoded }}
              </h1>
            </div>

            <div class="l_flex l_flex-top-children" *ngIf="!isMobile">
              <button
                *ngIf="ownerIsViewing"
                df-button
                dfButtonType="passive"
                class="
                  bg-color-white
                  color-ebony-a61
                  guts-m-r-half guts-p-h-3-quart
                "
                data-dgat="_UserInfoPartial-9c5"
                (click)="goToSettings()"
                [attr.aria-label]="i18n.dgUserOverview_Settings"
              >
                <df-icon icon="gear" class="color-ebony-a61"></df-icon>
              </button>

              <dgx-follow-profile-button
                *ngIf="!ownerIsViewing"
                [owner]="profile"
                [showFollowingLabel]="true"
                buttonClasses="
                bg-color-white guts-m-r-half color-ebony-a61
              "
              >
              </dgx-follow-profile-button>

              <dgx-connect-with-mentor-button
                *ngIf="
                  showMentorOptions && mentor.mentorshipStatus !== 'Accepted'
                "
                [mentor]="mentor"
                buttonClasses="bg-color-white guts-m-r-half color-ebony-a61"
              ></dgx-connect-with-mentor-button>

              <div *ngIf="showMenu" class="l_flex m-l_flex">
                <dgx-menu
                  [appendToBody]="true"
                  [menuConfig]="menuConfig"
                  [autoCloseOnItemSelect]="true"
                  class="guts-m-r-half"
                  placement="bottom-right"
                >
                  <button
                    [attr.aria-label]="i18n.Core_MoreOptions"
                    df-button
                    dfButtonType="passive"
                    data-dgat="user-info-8d8"
                    class="bg-color-white guts-p-h-3-quart"
                  >
                    <df-icon icon="dots" class="color-ebony-a61"></df-icon>
                  </button>
                </dgx-menu>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              !bio &&
              !options.isRestrictedProfile &&
              ownerIsViewing &&
              !isManagedProfile
            "
            class="l_flex m-l_flex m-l_flex-justify-center guts-p-t-half"
          >
            <button
              df-button
              dfButtonType="clear"
              class="color-blue l_flex-bottom show-more-button"
              (click)="goToSettings()"
              data-dgat="user-info-312"
            >
              <div class="l_flexbar">
                <df-icon icon="plus" size="small"></df-icon>
                <div>{{ i18n.Core_AddBio }}</div>
              </div>
            </button>
          </div>

          <div
            *ngIf="!!bio && !options.isRestrictedProfile"
            class="par m-guts-m-r-0 guts-p-full-0 l_flex l_flex-column"
            [attr.aria-label]="i18n.User_BioLabel"
          >
            <p
              [dgxLineClampHtml]="bio"
              [clampLinesMax]="4"
              class="par m-l_flex-col-1 m-center-text"
              (clamped)="onBioClamped($event)"
              (click)="displayShowMore && showBioModal()"
              [attr.role]="displayShowMore ? 'button' : 'presentation'"
              data-dgat="user-info-5da"
              tabindex="0"
            ></p>

            <div
              class="l_flex m-l_flex m-l_flex-justify-center"
              *ngIf="displayShowMore"
            >
              <button
                df-button
                dfButtonType="clear"
                class="color-blue l_flex-bottom show-more-button"
                (click)="showBioModal()"
                data-dgat="user-info-312"
                [attr.aria-expanded]=""
              >
                <div class="l_flexbar gap-full-half">
                  <div>{{ i18n.Core_ShowMore }}</div>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div class="l_flex">
          <div
            *ngIf="!options.viewerIsBlocked && isAuthenticated && !isMobile"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <ul class="l_flex m-l_flex m-l_flex-justify-center header-details-container">
    <li
      class="l_flex"
      *ngIf="profile.location || (ownerIsViewing && !isManagedProfile)"
    >
      <div>
        <div
          *ngIf="!!profile.location"
          class="static-user-info-meta-label ellipsis guts-m-b-quart"
          [ngbTooltip]="profile.location | ellipsis: metaLabelTooltipTextLimit"
          [disableTooltip]="profile.location.length <= metaLabelTextLimit"
          [attr.aria-label]="locationLabel"
          tabindex="0"
        >
          {{ profile.location | ellipsis: metaLabelTextLimit }}
        </div>
        <div
          *ngIf="!profile.location && ownerIsViewing && !isManagedProfile"
          class="l_flex l_flex-center"
        >
          <button
            df-button
            dfButtonType="clear"
            class="color-blue l_flex-bottom l_flex-center show-more-button"
            (click)="goToSettings()"
            data-dgat="user-info-c4b"
            [attr.aria-label]="i18n.Core_AddLocation"
          >
            <div class="l_flexbar">
              <df-icon icon="plus" size="small"></df-icon>
              <div>{{ i18n.Core_Add }}</div>
            </div>
          </button>
        </div>
        <span class="profile-header-label" tabindex="-1">
          {{ i18n.Core_Location }}
        </span>
      </div>
    </li>

    <li
      class="l_flex"
      *ngIf="profile.jobRole || (ownerIsViewing && !isManagedProfile)"
    >
      <div
        class="l_flex-column"
        role="button"
        [attr.aria-label]="i18n.Core_JobRoleLiteral"
      >
        <div
          *ngIf="!!profile.jobRole"
          class="static-user-info-meta-label guts-m-b-quart"
          [ngbTooltip]="profile.jobRole | ellipsis: metaLabelTooltipTextLimit"
          [disableTooltip]="profile.jobRole.length <= metaLabelTextLimit"
          tabindex="0"
          [attr.aria-label]="jobRoleLabel"
        >
          {{ profile.jobRole | ellipsis: metaLabelTextLimit }}
        </div>

        <div
          *ngIf="!profile.jobRole && ownerIsViewing && !isManagedProfile"
          class="l_flex l_flex-center"
        >
          <button
            df-button
            dfButtonType="clear"
            class="color-blue l_flex-bottom l_flex-center show-more-button"
            (click)="goToSettings()"
            data-dgat="user-info-312"
            tabindex="0"
            [attr.aria-label]="i18n.Core_AddJobRole"
          >
            <div class="l_flexbar">
              <df-icon icon="plus" size="small"></df-icon>
              <div>{{ i18n.Core_Add }}</div>
            </div>
          </button>
        </div>
        <span class="profile-header-label" tabindex="-1">
          {{ i18n.Core_JobRoleLiteral }}
        </span>
      </div>
    </li>

    <li class="l_flex" *ngIf="!hideCounts && vm.followersLabel">
      <button
        df-button
        dfButtonType="clear"
        class="l_flex m-l_flex l_flex-column"
        (click)="showSocialModal('followers')"
        tabindex="0"
      >
        <div class="user-info-meta-label guts-m-b-quart">
          {{ vm.followersCount }}
        </div>
        <div class="profile-header-label">
          {{ i18n.Core_Followers }}
        </div>
      </button>
    </li>

    <li class="l_flex" *ngIf="!hideCounts && vm.followingLabel">
      <button
        df-button
        dfButtonType="clear"
        class="l_flex m-l_flex l_flex-column"
        (click)="showSocialModal('following')"
        role="button"
        tabindex="0"
      >
        <div class="user-info-meta-label guts-m-b-quart">
          {{ vm.followeesCount }}
        </div>
        <div class="profile-header-label">
          {{ i18n.Core_Following }}
        </div>
      </button>
    </li>

    <li class="l_flex" *ngIf="!hideCounts && vm.groupsLabel">
      <button
        df-button
        dfButtonType="clear"
        class="l_flex m-l_flex l_flex-column"
        (click)="showSocialModal('groups')"
        role="button"
        tabindex="0"
      >
        <div class="user-info-meta-label guts-m-b-quart">
          {{ vm.groupsCount }}
        </div>
        <div class="profile-header-label">
          {{ i18n.Core_Groups }}
        </div>
      </button>
    </li>
  </ul>
</ng-container>
